import React, { Component } from 'react';
import { Link } from 'react-router';
import SiteHead from '../shared/components/header';

import 'bootstrap/dist/css/bootstrap.min.css';
import './app.css';
import './index.css';
import './bootstrap-multiselect.css';
import { Provider } from 'react-redux';
import configureStore from '../shared/store/configureStore';
import { DragDropContextProvider } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';

const store = configureStore();

class App extends Component {
	constructor(props) {
		super(props);
		this.state = { navMini: false };
		this.logout = this.logout.bind(this);
	}

	logout() {
		// Logout handler
	}

	render() {
		const currentPath = this.props.location.pathname;
		const isLoginPage = currentPath === '/';

		return (
			<div className="app-wrapper">
				{!isLoginPage && <SiteHead logout={this.logout} />}
				
				{!isLoginPage && (
					<nav className="top-nav">
						<Link to="/dashboard" className="top-nav-item" activeClassName="active">
							Overview
						</Link>
						<Link to="/periodical_master" className="top-nav-item" activeClassName="active">
							Periodical Master
						</Link>
						<Link to="/accurence_master" className="top-nav-item" activeClassName="active">
							Frequency Master
						</Link>
						<Link to="/periodical_configuration" className="top-nav-item" activeClassName="active">
							Allocation
						</Link>
						<Link to="/periodical_scheduling" className="top-nav-item" activeClassName="active">
							Scheduling
						</Link>
						<Link to="/reports" className="top-nav-item" activeClassName="active">
							Periodical Report
						</Link>
						<Link to="/status_view" className="top-nav-item" activeClassName="active">
							Status View
						</Link>
					</nav>
				)}

				<div className="content-container">
					<Provider store={store}>
						<DragDropContextProvider backend={HTML5Backend}>
							{this.props.children}
						</DragDropContextProvider>
					</Provider>
				</div>

				{!isLoginPage && (
					<footer className="footer">
						<span>
							© {`${new Date().getFullYear()}`} Asepsis Pty Ltd. All rights
							reserved. Powered by Asepsis.{' '}
							<img src={'/favicon-2.png'} width={30} alt="Asepsis" />
						</span>
					</footer>
				)}
			</div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/web/App.js